import {
  getColumnSubTotal,
  SUBTOTAL_NOT_AVAILABLE,
} from '../Exports/exports.helpers';

export { SUBTOTAL_NOT_AVAILABLE };

export const isSummableWorkReportColumn = (col) => {
  if (!col?.dataIndex || col.dataIndex === '' || col.doNotCalculate) return false;
  return col.type === 'calculation' || col.isCalculation || col.type === 'text';
};

export const getWorkReportColumnSum = (col, rows = []) => getColumnSubTotal({ field: col.dataIndex }, rows, { [col.dataIndex]: { selectedType: 'calculation' } });
